import { render, staticRenderFns } from "./TaskCloseManuallyModal.vue?vue&type=template&id=553a3e65&"
import script from "./TaskCloseManuallyModal.vue?vue&type=script&lang=js&"
export * from "./TaskCloseManuallyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports